<template>
  <!--错误信息详情-->
  <div id="myErrorMessageList">
    <div class="allBody">
      <nav class="allTop">
        <img src="../../../assets/home01.png" width="100%" height="60"/>
        <div>数据上传 > {{upHistName}}错误信息详情</div>
      </nav>
      <div>
        <div class="allDl d_flex m_t_20 m_b_10">
          <div class="colorYellowF36A20 font14">
            <i class="icon iconfont icongantan"></i>
            <span class="f_w" style="vertical-align: bottom">如需获取更多数据，请下载全部错误信息</span>
          </div>
          <div>
            <button @click="confirmExport()" class="suerButton"><span class="m_l_5">下载全部错误信息</span></button>
            <button @click="loUrl()" class="suerButton m_l_5"><span class="m_l_5">返回</span></button>
          </div>
        </div>
        <div style="max-height: calc(100vh - 120px);overflow: auto">
          <table class="allTable" cellspacing="0">
            <thead>
            <tr>
              <th>Sheet名</th>
              <th>行号</th>
              <th>列名</th>
              <th>所填内容</th>
              <th>错误信息</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in myErroerList">
              <td>{{ item.sheetName }}</td>
              <td>{{ item.rowNumber }}</td>
              <td>{{ item.columnName }}</td>
              <td><span class="Newline dis_line" style="max-width: 500px">{{ item.content }}</span></td>
              <td>{{ item.summary }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <page :totalCount="totalCount" v-if="totalPage !== 0" v-on:on-getList="getAllList($event)" :totalPage="totalPage" :page="page" :numPage="1"></page>
      </div>
    </div>
    <model v-if="showModel4" :title="'正在下载'" :minWidth="'60%'" :showClose="1" :onButton="0" v-on:on-cancel="showModel3 = false">
      <div class="pd_10_20">
        <div class="filrProgNum" style="margin: auto">
          <p class="d_flex">
            <span>{{ upName }}</span>
            <span class="colorGray9D9D9D">{{ uploadMdoel }}%</span>
          </p>
          <div class="m_t_5 m_b_5">
            <div :style="{'width': uploadMdoel + '%'}"></div>
          </div>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'myErrorMessageList',
  data () {
    return {
      showModel4: false,
      uploadMdoel: 0,
      upName: '',
      formId: parseInt(this.$route.query.formId),
      upHistName: JSON.parse(JSON.stringify(localStorage.upHistName)) || '',
      totalPage: 0,
      totalCount: 0,
      page: 1,
      postData: {
        hisid: 0,
        PageIndex: 1,
        PageSize: 10
      },
      myErroerList: []
    }
  },
  created () {
    this.getAllList(1)
  },
  mounted () {
  },
  methods: {
    loUrl () {
      this.$router.go(-1)
    },
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.PageIndex = page
      data.hisid = this.formId
      let url = this.$commonJs.returnQuery('/api/File/GetUploadErrorList', data)
      this.$axiox.get(url).then(msg => {
        console.log(msg)
        this.myErroerList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    //  下载
    confirmExport () {
      let that = this
      that.$commonJs.addLog('导出错误日志', '数据上传', '', this.upHistName)
      let upName = that.upHistName.split('.')[that.upHistName.split('.').length - 2] + '-ErrorLog.xlsx'
      let url = ''
      that.uploadMdoel = 0
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + '/api/File/DownloadErrorList?hisid=' + this.formId
      xmlResquest.open('GET', url, true)
      xmlResquest.onprogress = function (e) {
        var percent = e.loaded / e.total
        that.uploadMdoel = parseInt(percent * 100)// progress 在data中定义的全局变量，显示的进度
        // console.log(that.uploadPercent)
        that.upName = upName
        that.showModel4 = true
      }
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            that.showModel4 = false
            return
          }
        }
        var elink = document.createElement('a')
        elink.download = upName
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
        that.showModel4 = false
      }
      xmlResquest.send()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/myHome/myErrorMessageList.vue